<template>
  <div class="Productdetail">
    <div class="wrapper-content">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{productName}}</h2>
          <p>
            <router-link to="/">{{ $t('message.Categories') }}</router-link>/
            <router-link
              :to="{ name: 'subcategory', params: { subcategoryname: $route.params.categoryname }}"
            >{{categoryName}}</router-link>/
            <router-link
              :to="{ name: 'product', params: {categoryname:$route.params.categoryname, name: $route.params.subcategoryName }}"
            >{{subCategoryName}}</router-link>
            / {{productName}}
          </p>
        </div>
      </div>

      <div class="container productDetailsPage">
        <div class="row">
          <div class="col-md-3 productListingCategoryArea" v-show="toggle">
            <div class="product-left panel">
              <div id="accordion">
                <div class="card categoryCard">
                  <div class="card-header" id="headingOne">
                    <h5 class="productLeftHeading">{{ $t('message.Categories') }}</h5>
                  </div>

                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <ul>
                        <li v-for="(category, index) in categoryItems" :key="index">
                          <div
                            class="pointer"
                            v-on:click="openSubcategories(category.id,category.meta.meta_slug)"
                          >{{category.name}}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9 productListingArea">
            <div class="product-right">
              <div class="row">
                <div class="col-md-5 col-sm-12">
                  <div class="slide_bx panel" v-if="productDetail">
                    <b-carousel
                      id="carousel-1"
                      v-model="slide"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      style="text-shadow: 1px 1px 2px #333;"
                      @sliding-start="onSlideStart"
                      @sliding-end="onSlideEnd"
                      v-if="productDetail.new_bulk_images.length>1"
                    >
                      <div v-for="(img,index) in productDetail.new_bulk_images" :key="index">
                        <b-carousel-slide :img-src="imageBaseUrl+img" alt="banner"></b-carousel-slide>
                      </div>
                    </b-carousel>

                    <img :src="imageBaseUrl+ productDetail.image" v-else />
                  </div>
                </div>
                <div class="col-md-7 col-sm-12">
                  <div class="panel">
                    <h2>{{productDetail.name}}</h2>
                    <p>{{productDetail.description}}</p>
                    <div class="quantity" v-if="productDetail.is_configurable==1">
                      <b-form-select
                        v-model="productSelected"
                        v-on:change="optionSelected($event,productDetail.id)"
                      >
                        <b-form-select-option :value="null">{{ $t('message.SelectOption') }}</b-form-select-option>
                        <b-form-select-option
                          :value="a.name"
                          v-for="(a,index) in productDetail.product_children"
                          :key="index"
                        >{{a.name}}</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="price" v-if="productDetail.is_configurable==0">
                      {{currency}} {{productDetail.price_per_unit.toFixed(2)}}
                      (
                      <strike>{{currency}}{{productDetail.mrp_single.toFixed(2)}}</strike>)
                    </div>

                    <div class="price" v-else>
                      <div v-if="selected">
                        {{currency}}{{productPrice()}}
                        (
                        <strike>{{currency}}{{productMrp()}}</strike>)
                      </div>
                    </div>
                    <br />
                    <div class="line"></div>
                    <div class="quantity" v-if="productDetail.is_configurable==0">
                      <ul>
                        <li>
                          <label class="cust">{{ $t('message.SelectQuantity') }}</label>

                          <div class="qty_dv">
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-btn variant="info" @click="decrement()">-</b-btn>
                              </b-input-group-prepend>

                              <b-form-input type="number" min="0.00" :value="quantity"></b-form-input>

                              <b-input-group-append>
                                <b-btn variant="info" @click="increment()">+</b-btn>
                              </b-input-group-append>
                            </b-input-group>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="quantity" v-else>
                      <ul>
                        <li>
                          <label class="cust">{{ $t('message.SelectQuantity') }}</label>

                          <div class="qty_dv">
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-btn variant="info" @click="decrement()" v-if="selected">-</b-btn>
                                <b-btn variant="info" @click="decrement()" disabled v-else>-</b-btn>
                              </b-input-group-prepend>

                              <b-form-input type="number" min="0.00" :value="quantity"></b-form-input>

                              <b-input-group-append>
                                <b-btn variant="info" @click="increment()" v-if="selected">+</b-btn>
                                <b-btn variant="info" @click="increment()" disabled v-else>+</b-btn>
                              </b-input-group-append>
                            </b-input-group>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="total_amt">
                    {{ $t('message.Total') }}
                    <div
                      v-if="productDetail.is_configurable==0&&productDetail.price_per_unit"
                    >({{currency}}{{productDetail.price_per_unit.toFixed(2)}}*{{quantity}})</div>
                    <div
                      v-else-if="selected&&productDetail.is_configurable==1"
                    >({{currency}}{{productPrice()}}*{{quantity}})</div>
                    <span>{{totalPrice}}</span>
                  </div>
                  <div class="btn_rw" v-if="productDetail.is_configurable==0">
                    <button
                      v-on:click="gotoStore"
                      class="btn btn-primary activebtn"
                    >{{ $t('message.Subscribe') }}</button>
                    <button
                      v-on:click="gotoStore"
                      class="btn btn-primary cancel"
                    >{{ $t('message.OneTimeOrder') }}</button>
                  </div>
                  <div class="btn_rw" v-else>
                    <button
                      v-on:click="gotoStore"
                      class="btn btn-primary activebtn"
                      v-if="selected"
                    >{{ $t('message.Subscribe') }}</button>
                    <button
                      class="btn btn-primary activebtn"
                      disabled
                      v-else
                    >{{ $t('message.Subscribe') }}</button>
                    <button
                      v-on:click="gotoStore"
                      class="btn btn-primary cancel"
                      v-if="selected"
                    >{{ $t('message.OneTimeOrder') }}</button>

                    <button
                      v-on:click="gotoStore"
                      class="btn btn-primary cancel"
                      disabled
                      v-else
                    >{{ $t('message.OneTimeOrder') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {
  getProductDetail,
  getMeta,
  getProductUnitNameAndChildren,
  getSlugBaseInfo,
  getCategories
} from "./../services/api";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel.css";
import "../../node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueSlickCarousel from "vue-slick-carousel";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import VueMeta from "vue-meta";
import Vue from "vue";
import VueLazyload from "vue-lazyload";
Vue.use(VueMeta);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});
export default {
  name: "product",
  components: {
    Datepicker,
    Loading,
    VueSlickCarousel
  },
  data() {
    return {
      currency: localStorage.getItem("CurrencySymbol"),
      slide: 0,
      sliding: null,
      toggle: true,
      categoryItems: [],
      isLoading: false,
      fullPage: true,
      imageBaseUrl: process.env.VUE_APP_Image_BASE_URL,
      categoryName: "",
      subCategoryName: "",
      productName: "",
      descriptionMeta: "",
      titleMeta: "",
      keywordsMeta: "",
      productSelected: null,
      selected: "",
      productDetail: "",
      quantity: 1
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content: this.descriptionMeta
        },
        {
          name: "title",
          content: this.titleMeta
        },
        {
          name: "keywords",
          content: this.keywordsMeta
        }
      ]
    };
  },
  computed: {
    totalPrice() {
      if (this.productDetail.is_configurable == 0) {
        var ttl = this.productDetail.price_per_unit * this.quantity;
        return this.currency + ttl.toFixed(2);
      } else {
        if (this.selected) {
          var ttl = this.productPrice() * this.quantity;
          return this.currency + ttl.toFixed(2);
        }
      }
    }
  },

  created() {
    this.getDetails();
    this.getCategoriesDetails();
    var a =
      this.$route.params.subcategoryName.charAt(0).toUpperCase() +
      this.$route.params.subcategoryName.slice(1);
    this.subCategoryName = a.replace(/[0-9]/g, "").replace(/-/g, " ");
  },

  methods: {
    subscribeThis(prod) {
      this.$router.replace({ name: "productdetail" });
      localStorage.setItem("productId", this.productDetail.id);
    },
    openSubcategories(id, name) {
      localStorage.setItem("categoryId", id);

      this.$router.replace({
        name: "subcategory",
        params: { subcategoryname: name }
      });
    },
    getCategoriesDetails() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId")
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId")
        };
      }
      getCategories(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.categoryItems = result.data.allCategoryProductsList;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    optionSelected(arg, id, index) {
      this.selected = arg;
    },
    productPrice: function() {
      var itemProduct = this.productDetail.product_children.find(
        i => i.name == this.selected
      );
      return itemProduct.price.toFixed(2);
    },
    productMrp() {
      var itemProduct = this.productDetail.product_children.find(
        i => i.name == this.selected
      );

      return itemProduct.mrp_child;
    },
    gotoStore() {
      window.open(localStorage.getItem("androidPlaystore"), "_blank");
      // var existing = JSON.parse(localStorage.getItem("selectedProduct"));

      // existing = existing ? existing : [];
      // var productsToadd = {
      //   items: this.productDetail,
      //   quantity: this.quantity
      // };
      // existing.push(productsToadd);

      // localStorage.setItem("selectedProduct", JSON.stringify(existing));
    },
    getProductMeta() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId"),
          type: "product",
          meta_id: localStorage.getItem("productId")
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId"),
          type: "product",
          meta_id: localStorage.getItem("productId")
        };
      }
      getMeta(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.titleMeta = result.data.data.meta_title;
            this.descriptionMeta = result.data.data.meta_description;
            this.keywordsMeta = result.data.data.meta_keywords;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 0) {
      } else {
        this.quantity--;
      }
    },
    getDetails() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId"),
          product: localStorage.getItem("productId"),
          type: "Product"
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId"),
          product: localStorage.getItem("productId"),
          type: "Product"
        };
      }

      this.isLoading = true;
      getProductDetail(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.productDetail = result.data.allCategoryProductsList[0];
            console.log("*", this.productDetail);
            this.categoryName =
              result.data.allCategoryProductsList[0].categoryName;
            this.productName = result.data.allCategoryProductsList[0].name;
            this.isLoading = false;
            this.getProductMeta();
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },
    getotherDetails() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId"),
          product: localStorage.getItem("productId"),
          type: "Product"
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          product: localStorage.getItem("productId"),
          vendor_id: localStorage.getItem("vendorId")
        };
      }

      getProductUnitNameAndChildren(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>
